<template>
	<div>
		<div style="text-align: left;">
			<el-button type="primary" size="mini" @click="openDialog($event, 'new')">添加</el-button>
			<el-button type="primary" size="mini" @click="openDialog($event, 'edit')">编辑</el-button>
			<el-button type="warning" size="mini" @click="delAnchor" :disabled="!currentID">删除</el-button>
			<el-button type="primary" size="mini" @click="shunxu('up')" :disabled="!currentID"><i class="el-icon-top move-icon"></i>上移</el-button>
			<el-button type="primary" size="mini" @click="shunxu('down')" :disabled="!currentID"><i class="el-icon-bottom move-icon"></i>下移</el-button>
			<el-button type="primary" size="mini" @click="refreshAnchorShunxu()" :disabled="anchorList.length==0"><i class="el-icon-refresh"></i>重算顺序</el-button>
			
		</div>
		<el-table :data="anchorList" @row-click="rowClick" ref="tabRef" :highlight-current-row="true">
			<el-table-column type="index" width="50" align="center"></el-table-column>
			<el-table-column property="锚点名称" label="锚点名称" width="150" header-align="center"></el-table-column>
			<el-table-column property="锚点ID" label="锚点ID" width="200" header-align="center"></el-table-column>
			
		</el-table>
		<el-dialog
			width="400px"
			:title="dialogTitle"
			:visible.sync="dialogVisible"
			:close-on-click-modal="false"
			id="newDialog"
			ref="dialogRef"
			append-to-body>
			<el-form :model="form" ref="form" :rules="rules">
				<el-form-item label="锚点名称" prop="锚点名称" label-width="100px">
					<el-input v-model="form.锚点名称" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item label="锚点ID" prop="锚点ID" label-width="100px">
					<el-input v-model="form.锚点ID" autocomplete="off" placeholder="锚点ID只能字母+数字，不能包含空格"></el-input>
					<div v-if="formType=='edit'" style="text-align: left; color: red;">注：修改锚点ID原来插入的锚点会失效，需重新插入。</div>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button type="primary" size="mini" @click="submit">确 定</el-button>
				<el-button type="warning" size="mini" @click="dialogVisible = false">取 消</el-button>
				
			</div>
		</el-dialog>
		<div slot="footer" class="dialog-footer">
			<el-button type="warning" size="mini" @click="close" style="margin-top: 10px;">关闭</el-button>
			
		</div>
	</div>
</template>

<script>
	import * as util from "@/utils/util.js"
	
	export default {
	  data() {
	    return {
	      form: {
					AutoID: '0',
					锚点名称: '',
					锚点ID: '',
					
				},
				rules: {
				  锚点名称: [
				    {required: true, message: '请输入锚点名称', trigger: 'change'}
				  ],
					锚点ID: [
					  {required: true, message: '请输入锚点ID', trigger: 'change'}
					],
					
				},
				dialogVisible: false,
				dialogTitle: '',
				anchorList: [],
				currentRow: '',
				currentID: '',
				formType: '',
				
	    }
	  },
	  methods: {
	    getAnchorList(){
				let url="/Handler/Anchor.ashx?mode=GetAnchorList";
				this.loaded=false;
				
				let payload={
					MainID: this.MainID
				}
				
				this.$ajax.post(url,payload).then(
				  response => {
				    //console.log(response.data);
						let errorCode=response.data.errorCode;
						
						if(errorCode=='0'){
							this.anchorList=response.data.data;
							
							let row = this.anchorList.find(item => item.AutoID == this.currentRow.AutoID);
							this.$refs.tabRef.setCurrentRow(row);
							
							this.$emit('change');
						}
				    else{
							let desc=value.desc;
							this.$alert('获取失败：' +　desc, '系统提示', {
							  confirmButtonText: '确定',
							  callback: action => {
							
							  }
							});
						}
						
						//console.log(this.sltList);
						setTimeout(()=>{
							this.loaded=true;
						},150);
						
				  },
				  function(err) {
				    console.log(err);
						
				  }
				);
				
			},
			openDialog(event, type){
				
				if(type=='new'){
					this.dialogTitle='新建锚点';
					
					this.form = {
						AutoID: '0',
						锚点名称: '',
						锚点ID: '',
						
					}
				}
				else if(type=='edit'){
					if(!this.currentID){
						this.$message({
						  type: 'error',
						  message: '请选择要编辑的锚点'
						});
						return;
					}
					
					this.form=JSON.parse(JSON.stringify(this.currentRow));
					
					this.dialogTitle='编辑锚点';
				}
				
				this.dialogVisible=true;
				this.formType=type;
				
				let weizhi = util.WeiZhi(event, 550, 600, 0, 0, 1);
				//console.log(weizhi);
				
				let l = weizhi.left;
				let t = weizhi.top;
				
				const el = document.querySelector('#newDialog');;
				const dragDom = el.querySelector('.el-dialog');
				
				dragDom.style.marginTop = '0px';
				dragDom.style.left = l + 'px';
				dragDom.style.top = t + 'px';
				dragDom.style.width =  '500px';
			},
			delAnchor(){
				if(!this.currentID){
					this.$message({
					  type: 'error',
					  message: '请选择要删除的锚点'
					});
					return;
				}
				this.$confirm('确定要删除吗?', '提示', {
				  cancelButtonClass: 'btn-custom-cancel',
				  confirmButtonText: '确定',
				  cancelButtonText: '取消',
				  type: 'warning',
				  center: false,
				}).then(() => {
				
				  var url="/Handler/Anchor.ashx?mode=delAnchor";
				  this.$ajax.post(url,{AutoID: this.currentID, MainID: this.MainID}).then((response)=>{
				    //console.log(response.data);
				    //let jsonData=JSON.parse(response.bodyText);
				    //console.log(jsonData[0]);
						if(response.data.errorCode=='0'){
							this.currentID=0;
							this.getAnchorList();
						}
				    else{
							
							this.$message({
							  type: 'error',
							  message: '删除失败'
							});
						}
				
				  },function(err){
				    console.log(err);
				  });
				});
				
			},
			submit(){
				this.$refs['form'].validate(async (valid) => {
				  if (valid) {
				    //console.log(JSON.stringify(this.form));
				    //alert('submit!');
						this.form.MainID=this.MainID;
						
						var url="/Handler/Anchor.ashx?mode=" + this.formType;
						this.$ajax.post(url,this.form).then((response)=>{
						  //console.log(response.data);
						
						  let value=response.data;
						
						  let errorCode=value.errorCode;
						
						  if(errorCode=="0")
						  {
						    this.$message({
						      type: 'success',
						      message: '保存成功:'
						    });
						    this.dialogVisible=false;
								
						    this.getAnchorList();
						  }
						  else
						  {
						    let desc=value.desc;
						    this.$alert('保存失败：' +　desc, '系统提示', {
						      confirmButtonText: '确定',
						      callback: action => {
						    
						      }
						    });
						  }
						
						},function(err){
						  console.log(err);
						});
				
				  } else {
				    console.log('error submit!!');
				    return false;
				  }
				});
			},
			rowClick(row, column, event){
				this.currentRow=row;
				this.currentID=row.AutoID;
				
			},
			close(){
				this.$emit('close');
			},
			shunxu(type) { //利用lodashJS防抖动，间隔30毫秒移动一次顺序
			  //console.log(type,this.asideWidth);
			  if (this.currentID == 0) {
			    this.$message({
			      type: 'error',
			      message: '请先选择要调整的文档'
			    });
			    return;
			  }
			  
			  let url="/Handler/Anchor.ashx?mode=" + type;
			  this.$ajax.post(url,{AutoID: this.currentID, MainID: this.MainID}).then((response)=>{
			    //console.log(response.data);
			    let value=response.data;
			  
			    let errorCode=value.errorCode;
			  
			    if(errorCode=="0")
			    {
			  
			      this.getAnchorList();
			  
			    }
			    else
			    {
			      let desc=value.desc;
			      this.$message({
			        type: 'error',
			        message: desc
			      });
			    }
				},function(err){
			    //console.log(err);
			  });
			  
			  //console.log(this.currentIndex);
			},
			refreshAnchorShunxu(){
			  
			  let url="/Handler/Anchor.ashx?mode=refreshAnchorShunxu";
			  this.$ajax.post(url,{MainID: this.MainID}).then((response)=>{
			    //console.log(response.data);
			    //let jsonData=JSON.parse(response.bodyText);
			    //console.log(jsonData[0]);
			    //this.currentID=0;
			    let value=response.data;
			
			    let errorCode=value.errorCode;
			
			    if(errorCode=="0")
			    {
			      this.$alert('重算顺序成功', '系统提示', {
			        confirmButtonText: '确定',
			        callback: action => {
			          this.getAnchorList();
			        }
			      });          }
			    else
			    {
			      let desc=value.desc;
			      this.$message({
			        type: 'error',
			        message: desc
			      });
			    }        },function(err){
			    //console.log(err);
			  });
			},
			
	  },
	  mounted(){
			
			this.getAnchorList();
			
	  },
		props:['MainID', 'type']
	}
</script>

<style>
</style>